import rjIcon from '../assets/rj.png';
import appStoreIcon from '../assets/mj_ios_qr.png';
import googlePlayIcon from '../assets/mj_andr_qr.png';
import Content from './content'

function RedMahjong() {
  return (
    <Content 
      icon={rjIcon}
      info={'Both Five Card and Six Card variations of cribbage are supported. As 6-card cribbage variation is the most common, it is a default variation. By default, the points will be scored automatically both during play and during show-of-cards. With Manual Scoring table option selected, both players will be forced to count their hands -- both during play and during show-of-cards. '}
      mobileLink={{
        ios: {
          qr: appStoreIcon,
          link: 'https://apps.apple.com/us/app/red-mahjong/id1412621908'
        },
        android: {
          qr: googlePlayIcon,
          link: 'https://play.google.com/store/apps/details?id=com.gameclubusa.redmahjonggc'
        }
      }}
    />
  );
}

export default RedMahjong;